import { Link } from 'react-router-dom';

interface PageHeroProps {
  title: string;
  subtitle: string;
  imageUrl: string;
  breadcrumb?: { label: string; href: string };
}

export default function PageHero({ title, subtitle, imageUrl, breadcrumb }: PageHeroProps) {
  return (
    <section className="relative w-full h-[320px] md:h-[400px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        {breadcrumb && (
          <div className="flex items-center gap-2 text-sm text-background-50/70 mb-3">
            <Link to={breadcrumb.href} className="hover:text-background-50 transition-colors">
              {breadcrumb.label}
            </Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-background-50/50">{title}</span>
          </div>
        )}
        <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4 max-w-3xl">
          {title}
        </h1>
        <p className="text-background-50/80 text-base md:text-lg max-w-2xl leading-relaxed">
          {subtitle}
        </p>
      </div>
    </section>
  );
}